import useContacts from "./useContacts"
import useViewer from "./useViewer"
import { get_ongoing_task } from "./utils";
import OperateService from "../../../service/OperateService";
import { showToastMessage } from "../../../utils/commonFunctions";


const useOnBoardSchedule = () => {
    const { current_simulation_time } = useViewer()
    const { scheduleData, scheduleDetails, timelineScheduleData, setSelectedScheduleTask, get_all_onboard_schedules } = useContacts()


    const select_schedule_data = (data: any) => {
        const ongoing_task = get_ongoing_task(current_simulation_time / 1000, scheduleData)
        setSelectedScheduleTask({
            default_schedule: (ongoing_task.length > 0 && ongoing_task[0].startTime === data.startTime) ? true : false,
            schedule_data: data,
        })
    }

    const exportOnBoardOperateSchedule = (mission_id : string | undefined, scenario_id : string | undefined, schedule_id : string | undefined)  => {
        OperateService.exportSchedule(mission_id, scenario_id, schedule_id)?.then((res) => {
            if (res?.data?.data) {
                // 1. Build a newline-delimited JSON string
                const lines: string[] = res.data.data.map((command: any) => {
                    return '\n' + JSON.stringify(command);
                });
                const payload = lines.join(',');

                // 2. Trigger file download
                const blob = new Blob([payload], { type: 'application/json' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'schedule.json';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);

                // 3. Show success toast. Use the API’s message if available:
                const successMsg = res.data.message || 'Schedule exported successfully';
                showToastMessage('success', successMsg);
            } else {
                // In the unlikely event that data is missing, still inform the user:
                showToastMessage('error', res.data.message || 'No scheduled tasks to export for the Scenario');
            }
        }).catch((err) => {
            showToastMessage('error', 'Schedule export failed');
        })
    }

    const deleteOnBoardOperateSchedule = (mission_id : string | undefined, scenario_id : string | undefined, schedule_id : string | undefined)  => {
        OperateService.deleteSchedule(mission_id, scenario_id, schedule_id)?.then((res) => {
            if (res?.data) {
                get_all_onboard_schedules()
                showToastMessage('success', res.data.message );
            } else {
                showToastMessage('error', res.data.message );
            }
        }).catch((err) => {
            showToastMessage('error', 'Error in Deleting Schedule');
        })
    }

    return {
        scheduleData,
        scheduleDetails,
        select_schedule_data,
        timelineScheduleData,
        exportOnBoardOperateSchedule,
        deleteOnBoardOperateSchedule
    }
}

export default useOnBoardSchedule